import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4537_2085)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12.11 5.36068C12.0177 5.20049 9.72681 1.5 6.18555 1.5C2.64429 1.5 0.353379 5.2085 0.261071 5.36068C0.160372 5.52087 0.160372 5.72112 0.261071 5.88131C0.353379 6.0415 2.64429 9.75 6.18555 9.75C9.72681 9.75 12.0177 6.0415 12.11 5.88131C12.2107 5.72112 12.2107 5.52087 12.11 5.36068V5.36068ZM6.18555 8.70073C3.76037 8.70073 1.931 6.40194 1.37716 5.61699C1.931 4.83204 3.76037 2.53325 6.18555 2.53325C8.61072 2.53325 10.4401 4.83204 10.9939 5.61699C10.4401 6.40194 8.61911 8.70073 6.18555 8.70073V8.70073Z",
			fill: "#2882DE"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M6.18577 3.4624C4.88507 3.4624 3.81934 4.43158 3.81934 5.62502C3.81934 6.81847 4.87668 7.78764 6.18577 7.78764C7.49486 7.78764 8.5522 6.81847 8.5522 5.62502C8.5522 4.43158 7.49486 3.4624 6.18577 3.4624ZM6.18577 6.73837C5.48087 6.73837 4.91025 6.23376 4.91025 5.62502C4.91025 5.01629 5.48087 4.50366 6.18577 4.50366C6.89067 4.50366 7.46129 5.00828 7.46129 5.62502C7.46129 6.24177 6.89067 6.73837 6.18577 6.73837Z",
			fill: "#2882DE"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4537_2085",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white",
			transform: "translate(0.185547)"
		})
	}) })]
});
export default SvgEye;
